if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
           console.log('Add to Cart button clicked');
             var freeGiftElement = document.querySelector(".free_giftEnabled");
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          // formData.append('', 4193714424);
          this.cart.setActiveElement(document.activeElement);
        }
       
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            // Fetch the cart data to add free gift
    fetch('/cart.js')
  .then(response => response.json())
  .then(parsedState => {
    // Extract total price once
    var totalPrice = parsedState.total_price / 100;
     // Check for second free gift element
    var freeGiftElements = document.querySelector(".free_giftEnableds");
    if (freeGiftElements) {
      // Get the variant ID and target price for the second free gift
      var variantid2 = freeGiftElements.getAttribute('data-freeitemids');
      var freeTarget2 = freeGiftElements.getAttribute('data-target');
      var targetvals2 = freeTarget2 / 100;
    console.log(targetvals2);
      // Check if the second free gift item is already in the cart
      var freeGiftExists2 = parsedState.items.some(function(item) {
        return item.variant_id == variantid2;
      });

     if(totalPrice >= targetvals2){
             //add the free gift if not exist already
              if (!freeGiftExists2) {
                $('.add_freeGiftss').trigger('click');
              } else {
             console.log('Free gift already exists in the cart.');
            }
             
           }else{
             //remove the free gift if exist already
             if (freeGiftExists2) {
              console.log('Total price is below the target. Removing first free gift...');
               console.log('ttfirst');
              $('.remove_freeGiftss').trigger('click');
            } else {
            console.log('Free gift not in the cart, no need to remove.');
            }
          }
    }

        // Check for first free gift element
    var freeGiftElement = document.querySelector(".free_giftEnabled");
    if (freeGiftElement) {
      // Get the variant ID and target price for the free gift
      var variantid = freeGiftElement.getAttribute('data-freeitemid');
      var freeTarget = freeGiftElement.getAttribute('data-target');
      var targetvals = freeTarget / 100;

      // Check if the free gift item is already in the cart
      var freeGiftExists = parsedState.items.some(function(item) {
        return item.variant_id == variantid;
      });

      if (totalPrice >= targetvals) {
        // Add the free gift if it doesn't already exist
        if (!freeGiftExists) {
          $('.add_freeGifts').trigger('click');
        } else {
          console.log('Free gift already exists in the cart.');
        }
      } else {
        // Remove the free gift if it exists and the total price is below target
        if (freeGiftExists) {
         //alert('ttsecond');
          console.log('Total price is below the target. Removing second free gift...');
          $('.remove_freeGifts').trigger('click');
        } else {
          console.log('Free gift not in the cart, no need to remove.');
        }
      }
    }

  
 
  })
  .catch(error => console.error('Error fetching cart data:', error));


// end of free gift
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
